import { render, staticRenderFns } from "./SfAccordionItem.vue?vue&type=template&id=eb8c62d0&"
import script from "./SfAccordionItem.vue?vue&type=script&lang=ts&"
export * from "./SfAccordionItem.vue?vue&type=script&lang=ts&"
import style0 from "./SfAccordionItem.vue?vue&type=style&index=0&id=eb8c62d0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports